import { gql } from "@apollo/client";

export const GET_INITIATIVE_REFERRAL_BY_ID = gql`
  query Query($getReferralByIdId: String!) {
    getReferralById(id: $getReferralByIdId) {
      id
      from
      status
      serviceName
      serviceId
      eligibilityStatus
      isSelfReferral
      orgId
      user {
        firstName
        lastName
        country
        email
        gender
        employmentStatus
        dob
        housingStatus
        incomeLevel
        insurance
        household
        phone
        updatedAt
      }
    }
  }
`;
